<template>
  <el-dialog :visible="show" append-to-body :title="row ? '修改小程序' : '新增小程序'" width="500px" @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm">
      <el-form-item label="小程序名称" prop="name" :rules="{ required: true, message: '名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>
      <el-form-item label="小程序简介" prop="describe" :rules="{ required: true, message: '简介必填' }">
        <el-input v-model="vForm.describe"></el-input>
      </el-form-item>
      <el-form-item label="APPID" prop="appid" :rules="{ required: true, message: 'APPID必填' }">
        <el-input v-model="vForm.appid"></el-input>
      </el-form-item>
      <!--      <el-form-item label="入口背景图" prop="backend_image" :rules="{required:true,message: '入口背景图必填'}">-->
      <!--        <u-image width="300"-->
      <!--                 height="100"-->
      <!--                 v-model="backend_image"-->
      <!--                 @change="(img)=>{vForm.backend_image = img.key;$refs.vForm.validateField('backend_image')}" />-->
      <!--      </el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['show', 'row'],

  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        id: '',
        name: '',
        describe: '',
        appid: '',
        // backend_image: ''
      },
      // backend_image: {key: '', preview: ''},
    };
  },

  mounted() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
      // this.backend_image = {key: this.row.backend_image, preview: this.row.backend_image_preview}
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交表单
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.shop[this.row ? 'edit' : 'add'](this.vForm);
        this.$message.success(!this.row ? '添加成功' : '修改成功');
        this.$emit('success', this.row ? '' : 1);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>
